
import { http } from '../../core';
import Config from "../../app.config";
const RequestbaseURL = http.create({ baseURL: Config.BASE_API });

export function getList(params) {
  return RequestbaseURL.get('/fault/v1/event/list', params)
}

export function statusList() {
  return RequestbaseURL.get('/fault/v1/flow_status/list')
}

export function eventDelete(params) {
  return RequestbaseURL.post('/fault/v1/event/delete', params)
}
